module.exports = __webpack_public_path__ + "img/pic-Visualguidance.d6c972bd.jpg";